{
  "labels": {
    "paste": "Vložiť",
    "pasteAsPlaintext": "Vložiť ako obyčajný text",
    "pasteCharts": "Vložiť grafy",
    "selectAll": "Vybrať všetko",
    "multiSelect": "Pridať prvok do výberu",
    "moveCanvas": "Pohyb plátna",
    "cut": "Vystrihnúť",
    "copy": "Kopírovať",
    "copyAsPng": "Kopírovať do schránky ako PNG",
    "copyAsSvg": "Kopírovať do schránky ako SVG",
    "copyText": "Kopírovať do schránky ako text",
    "copySource": "Kopírovať kód do schránky",
    "convertToCode": "Konvertovať na kód",
    "bringForward": "Presunúť o úroveň dopredu",
    "sendToBack": "Presunúť dozadu",
    "bringToFront": "Presunúť dopredu",
    "sendBackward": "Presunúť o úroveň dozadu",
    "delete": "Vymazať",
    "copyStyles": "Kopírovať štýly",
    "pasteStyles": "Vložiť štýly",
    "stroke": "Obrys",
    "background": "Pozadie",
    "fill": "Výplň",
    "strokeWidth": "Hrúbka obrysu",
    "strokeStyle": "Štýl obrysu",
    "strokeStyle_solid": "Plný",
    "strokeStyle_dashed": "Čiarkovaný",
    "strokeStyle_dotted": "Bodkovaný",
    "sloppiness": "Štylizácia",
    "opacity": "Priehľadnosť",
    "textAlign": "Zarovnanie textu",
    "edges": "Okraje",
    "sharp": "Ostré",
    "round": "Zaokrúhlené",
    "arrowheads": "Zakončenie šípky",
    "arrowhead_none": "Žiadne",
    "arrowhead_arrow": "Šípka",
    "arrowhead_bar": "Čiara",
    "arrowhead_circle": "Kruh",
    "arrowhead_circle_outline": "Kruh (obrys)",
    "arrowhead_triangle": "Trojuholník",
    "arrowhead_triangle_outline": "Trojuholník (obrys)",
    "arrowhead_diamond": "Diamant",
    "arrowhead_diamond_outline": "Diamant (obrys)",
    "fontSize": "Veľkosť písma",
    "fontFamily": "Písmo",
    "addWatermark": "Pridať \"Vytvorené s Excalidraw\"",
    "handDrawn": "Ručne písané",
    "normal": "Normálne",
    "code": "Kód",
    "small": "Malé",
    "medium": "Stredné",
    "large": "Veľké",
    "veryLarge": "Veľmi veľké",
    "solid": "Plná",
    "hachure": "Šrafovaná",
    "zigzag": "Cik-cak",
    "crossHatch": "Mriežkovaná",
    "thin": "Tenká",
    "bold": "Hrubá",
    "left": "Doľava",
    "center": "Na stred",
    "right": "Doprava",
    "extraBold": "Veľmi hrubá",
    "architect": "Architekt",
    "artist": "Umelec",
    "cartoonist": "Ilustrátor",
    "fileTitle": "Názov súboru",
    "colorPicker": "Výber farby",
    "canvasColors": "Použité na plátne",
    "canvasBackground": "Pozadie plátna",
    "drawingCanvas": "Kresliace plátno",
    "layers": "Vrstvy",
    "actions": "Akcie",
    "language": "Jazyk",
    "liveCollaboration": "Živá spolupráca...",
    "duplicateSelection": "Duplikovať",
    "untitled": "Bez názvu",
    "name": "Meno",
    "yourName": "Vaše meno",
    "madeWithExcalidraw": "Vytvorené s Excalidraw",
    "group": "Zoskupiť",
    "ungroup": "Zrušiť zoskupenie",
    "collaborators": "Spolupracovníci",
    "showGrid": "Zobraziť mriežku",
    "addToLibrary": "Pridať do knižnice",
    "removeFromLibrary": "Odstrániť z knižnice",
    "libraryLoadingMessage": "Načítavanie knižnice…",
    "libraries": "Prehliadať knižnice",
    "loadingScene": "Načítavanie scény…",
    "align": "Zarovnanie",
    "alignTop": "Zarovnať nahor",
    "alignBottom": "Zarovnať nadol",
    "alignLeft": "Zarovnať doľava",
    "alignRight": "Zarovnať doprava",
    "centerVertically": "Zarovnať zvislo na stred",
    "centerHorizontally": "Zarovnať vodorovne na stred",
    "distributeHorizontally": "Rozmiestniť vodorovne",
    "distributeVertically": "Rozmiestniť zvisle",
    "flipHorizontal": "Prevrátiť vodorovne",
    "flipVertical": "Prevrátiť zvislo",
    "viewMode": "Režim zobrazenia",
    "share": "Zdieľať",
    "showStroke": "Zobraziť výber farby pre obrys",
    "showBackground": "Zobraziť výber farby pre pozadie",
    "toggleTheme": "Prepnúť tému",
    "personalLib": "Moja knižnica",
    "excalidrawLib": "Excalidraw knižnica",
    "decreaseFontSize": "Zmenšiť veľkosť písma",
    "increaseFontSize": "Zväčšiť veľkosť písma",
    "unbindText": "Zrušiť previazanie textu",
    "bindText": "Previazať text s kontajnerom",
    "createContainerFromText": "Zabaliť text do kontajneru",
    "link": {
      "edit": "Upraviť odkaz",
      "editEmbed": "Editovať a zapustiť odkaz",
      "create": "Vytvoriť odkaz",
      "createEmbed": "Vytvoriť a zapustiť odkaz",
      "label": "Odkaz",
      "labelEmbed": "Zapustiť odkaz",
      "empty": "Nie je nastavený žiaden odkaz"
    },
    "lineEditor": {
      "edit": "Upraviť čiaru",
      "exit": "Ukončiť editovanie čiary"
    },
    "elementLock": {
      "lock": "Zamknúť",
      "unlock": "Odomknúť",
      "lockAll": "Zamknúť všetko",
      "unlockAll": "Odomknúť všetko"
    },
    "statusPublished": "Zverejnené",
    "sidebarLock": "Nechať bočný panel otvorený",
    "selectAllElementsInFrame": "Vybrať všetky prvky v ráme",
    "removeAllElementsFromFrame": "Odstrániť všetky prvky z rámu",
    "eyeDropper": "Vybrať farbu z plátna",
    "textToDiagram": "Text na diagram",
    "prompt": "Inštrukcia"
  },
  "library": {
    "noItems": "Zatiaľ neboli pridané žiadne položky...",
    "hint_emptyLibrary": "Vyberte položku z plátna pre jej pridanie do knižnice alebo použite knižnicu z verejného zoznamu knižníc nižšie.",
    "hint_emptyPrivateLibrary": "Vyberte položku z plátna pre jej pridanie do knižnice."
  },
  "buttons": {
    "clearReset": "Obnoviť plátno",
    "exportJSON": "Exportovať do súboru",
    "exportImage": "Exportovať obrázok...",
    "export": "Uložiť do...",
    "copyToClipboard": "Kopírovať do schránky",
    "save": "Uložiť do aktuálneho súboru",
    "saveAs": "Uložiť ako",
    "load": "Otvoriť",
    "getShareableLink": "Získať odkaz na zdieľanie",
    "close": "Zavrieť",
    "selectLanguage": "Zvoliť jazyk",
    "scrollBackToContent": "Vrátiť sa späť na obsah",
    "zoomIn": "Priblížiť",
    "zoomOut": "Oddialiť",
    "resetZoom": "Obnoviť priblíženie",
    "menu": "Ponuka",
    "done": "Hotovo",
    "edit": "Upraviť",
    "undo": "Späť",
    "redo": "Znova",
    "resetLibrary": "Obnoviť knižnicu",
    "createNewRoom": "Vytvoriť novú miestnosť",
    "fullScreen": "Celá obrazovka",
    "darkMode": "Tmavý režim",
    "lightMode": "Svetlý režim",
    "zenMode": "Režim zen",
    "objectsSnapMode": "Prichytiť k objektom",
    "exitZenMode": "Zrušiť režim zen",
    "cancel": "Zrušiť",
    "clear": "Vymazať",
    "remove": "Odstrániť",
    "embed": "Prepnúť zapustenie",
    "publishLibrary": "Uverejniť",
    "submit": "Potvrdiť",
    "confirm": "Potvrdiť",
    "embeddableInteractionButton": "Kliknite pre interakciu"
  },
  "alerts": {
    "clearReset": "Týmto sa vyčistí celé plátno. Ste si istí?",
    "couldNotCreateShareableLink": "Nepodarilo sa vytvoriť odkaz na zdieľanie.",
    "couldNotCreateShareableLinkTooBig": "Nepodarilo sa vytvoriť odkaz na zdieľanie: scéna je príliš veľká",
    "couldNotLoadInvalidFile": "Nepodarilo sa načítať nevalidný súbor",
    "importBackendFailed": "Nepdarilo sa importovanie zo serveru.",
    "cannotExportEmptyCanvas": "Nie je možné exportovať prázdne plátno.",
    "couldNotCopyToClipboard": "Kopírovanie do schránky sa nepodarilo.",
    "decryptFailed": "Nepodarilo sa rozšifrovať údaje.",
    "uploadedSecurly": "Nahratie je zabezpečené end-to-end šifrovaním, takže Excalidraw server a tretie strany nedokážu prečítať jeho obsah.",
    "loadSceneOverridePrompt": "Nahratie externej kresby nahradí existujúci obsah. Prajete si pokračovať?",
    "collabStopOverridePrompt": "Ukončenie schôdze nahradí vašu predchádzajúcu lokálne uloženú scénu. Ste si istý?\n\n(Ak si chcete ponechať lokálnu scénu, jednoducho iba zavrite kartu prehliadača.)",
    "errorAddingToLibrary": "Nepodarilo sa pridať položku do knižnice",
    "errorRemovingFromLibrary": "Nepodarilo sa odstrániť položku z knižnice",
    "confirmAddLibrary": "Týmto sa pridá {{numShapes}} tvar(ov) do vašej knižnice. Ste si istí?",
    "imageDoesNotContainScene": "Tento obrázok neobsahuje žiadne údaje scény. Zvolili ste možnosť zahrnúť scénu počas exportu?",
    "cannotRestoreFromImage": "Nepodarilo sa obnoviť scénu z tohto obrázkového súboru",
    "invalidSceneUrl": "Nepodarilo sa načítať scénu z poskytnutej URL. Je nevalidná alebo neobsahuje žiadne validné Excalidraw JSON dáta.",
    "resetLibrary": "Týmto vyprázdnite vašu knižnicu. Ste si istý?",
    "removeItemsFromsLibrary": "Odstrániť {{count}} položiek z knižnice?",
    "invalidEncryptionKey": "Šifrovací kľúč musí mať 22 znakov. Živá spolupráca je vypnutá.",
    "collabOfflineWarning": "Internetové pripojenie nie je dostupné.\nVaše zmeny nebudú uložené!"
  },
  "errors": {
    "unsupportedFileType": "Nepodporovaný typ súboru.",
    "imageInsertError": "Nepodarilo sa vložiť obrázok. Skúste to znova neskôr...",
    "fileTooBig": "Súbor je príliš veľký. Maximálna povolená veľkosť je {{maxSize}}.",
    "svgImageInsertError": "Nepodarilo sa vložiť SVG obrázok. SVG formát je pravdepodobne nevalidný.",
    "failedToFetchImage": "Načítanie obrázka zlyhalo.",
    "invalidSVGString": "Nevalidné SVG.",
    "cannotResolveCollabServer": "Nepodarilo sa pripojiť ku kolaboračnému serveru. Prosím obnovte stránku a skúste to znovu.",
    "importLibraryError": "Nepodarilo sa načítať knižnicu",
    "collabSaveFailed": "Uloženie do databázy sa nepodarilo. Ak tento problém pretrváva uložte si váš súbor lokálne aby ste nestratili vašu prácu.",
    "collabSaveFailed_sizeExceeded": "Uloženie do databázy sa nepodarilo, pretože veľkosť plátna je príliš veľká. Uložte si váš súbor lokálne aby ste nestratili vašu prácu.",
    "imageToolNotSupported": "Obrázky sú vypnuté.",
    "brave_measure_text_error": {
      "line1": "Vyzerá to, že používate prehliadač Brave so zapnutým nastavením pre <bold>agresívne blokovanie</bold>.",
      "line2": "To môže spôsobiť nesprávne zobrazenie <bold>textových prvkov</bold> vo vašej kresbe.",
      "line3": "Dôrazne odporúčame vypnutie toho nastavenia. Môžete tak spraviť vykonaním <link>týchto krokov</link>.",
      "line4": "Ak vypnutie toho nastavenia nevyrieši problém so zobrazením textových prvkov, prosím ohláste <issueLink>problém</issueLink> na našom GitHub-e alebo nám napíšte na náš <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Zapustené prvky nie je možné pridať do knižnice.",
      "iframe": "Vložené rámce IFrame nie je možné pridať do knižnice.",
      "image": "Podpora pre pridávanie obrázkov do knižnice bude dostupná už čoskoro!"
    },
    "asyncPasteFailedOnRead": "Vloženie sa nepodarilo (nebolo možné prečítať obsah schránky).",
    "asyncPasteFailedOnParse": "Vloženie sa nepodarilo.",
    "copyToSystemClipboardFailed": "Kopírovanie do schránky sa nepodarilo."
  },
  "toolBar": {
    "selection": "Výber",
    "image": "Vložiť obrázok",
    "rectangle": "Obdĺžnik",
    "diamond": "Diamant",
    "ellipse": "Elipsa",
    "arrow": "Šípka",
    "line": "Čiara",
    "freedraw": "Kresliť",
    "text": "Text",
    "library": "Knižnica",
    "lock": "Nechať zvolený nástroj aktívny po skončení kreslenia",
    "penMode": "Režim pera – zabrániť dotyku",
    "link": "Pridať/ Upraviť odkaz pre vybraný tvar",
    "eraser": "Guma",
    "frame": "Nástroj rám",
    "magicframe": "Drôtený model na kód",
    "embeddable": "Web Embed",
    "laser": "Laserový ukazovateľ",
    "hand": "Ruka (nástroj pre pohyb plátna)",
    "extraTools": "Ďalšie nástroje",
    "mermaidToExcalidraw": "Mermaid do Excalidraw",
    "magicSettings": "AI nastavenia"
  },
  "headings": {
    "canvasActions": "Akcie plátna",
    "selectedShapeActions": "Akcie tvarov z výberu",
    "shapes": "Tvary"
  },
  "hints": {
    "canvasPanning": "Pre pohyb plátna podržte koliesko myši alebo medzerník počas ťahania, alebo použite nástroj ruka",
    "linearElement": "Kliknite na vloženie viacerých bodov, potiahnite na vytvorenie jednej priamky",
    "freeDraw": "Kliknite a ťahajte, pustite na ukončenie",
    "text": "Tip: text môžete pridať aj dvojklikom kdekoľvek, ak je zvolený nástroj výber",
    "embeddable": "Kliknite a ťahajte pre zapustenie webovej stránky",
    "text_selected": "Použite dvojklik alebo stlačte Enter na editáciu textu",
    "text_editing": "Stlačte Escape alebo CtrlOrCmd+ENTER na ukončenie editovania",
    "linearElementMulti": "Kliknite na počiatočný bod alebo stlačte Escape alebo Enter na ukončenie",
    "lockAngle": "Počas rotácie obmedzíte uhol podržaním SHIFT",
    "resize": "Počas zmeny veľkosti zachováte proporcie podržaním SHIFT,\\npodržaním ALT meníte veľkosť so zachovaním stredu",
    "resizeImage": "Podržte SHIFT pre voľnú zmenu veľkosti, podržte ALT pre zmenu veľkosti od stredu",
    "rotate": "Počas rotácie obmedzíte uhol podržaním SHIFT",
    "lineEditor_info": "Podržte CtrlOrCmd a kliknite dva krát alebo stlačte CtrlOrCmd + Enter pre editáciu bodov",
    "lineEditor_pointSelected": "Stačte Delete na vymazanie bodu (bodov), CtrlOrCmd+D na duplikovanie, alebo potiahnite na presunutie",
    "lineEditor_nothingSelected": "Zvoľte bod na upravovanie (podržte SHIFT pre zvolenie viacerých bodov) alebo podržte Alt a kliknite na pridanie nového bodu",
    "placeImage": "Kliknite pre umiestnenie obrázka alebo kliknite a ťahajte pre zmenu jeho veľkosti",
    "publishLibrary": "Uverejniť vašu knižnicu",
    "bindTextToElement": "Stlačte enter na pridanie textu",
    "deepBoxSelect": "Podržte CtrlOrCmd na výber v skupine alebo zamedzeniu poťiahnutia",
    "eraserRevert": "Podržte Alt pre prehodenie položiek určených na vymazanie",
    "firefox_clipboard_write": "Táto sa funkcionalita sa dá zapnúť nastavením \"dom.events.asyncClipboard.clipboardItem\" na \"true\". Pre zmenu nastavení vo Firefox-e otvorte stránku \"about:config\".",
    "disableSnapping": "Podržte CtrlOrCmd pre vypnutie prichytávania"
  },
  "canvasError": {
    "cannotShowPreview": "Nie je možné zobraziť náhľad plátna",
    "canvasTooBig": "Plátno je možno príliš veľké.",
    "canvasTooBigTip": "Tip: skúste presunúť najvzdialenejšie prvky bližšie k sebe."
  },
  "errorSplash": {
    "headingMain": "Nastala chyba. Vyskúšajte <button>obnoviť stránku.</button>",
    "clearCanvasMessage": "Ak obnovenie stránky nepomáha, vyskúšajte <button>vyčistiť plátno.</button>",
    "clearCanvasCaveat": " To bude mať za následok stratu práce ",
    "trackedToSentry": "Chyba s identifikátorom {{eventId}} bola zaznamenaná v našom systéme.",
    "openIssueMessage": "Boli sme veľmi opatrní, aby informácie vašej scény neboli v chybe zaznamenané. Ak vaša scéna nie je súkromná, prosím zvážte pokračovanie na naše <button>hlásenie chýb.</button> Prosím zahrňte informácie nižšie pomocou kopírovania a prilepenia do GitHub issue.",
    "sceneContent": "Obsah scény:"
  },
  "roomDialog": {
    "desc_intro": "Pozvite niekoho do svojej aktuálnej scény a pracujte spoločne.",
    "desc_privacy": "Nemajte obavy, schôdza používa end-to-end šifrovanie, takže všetko čo nakreslíte je súkromné. Dokonca, ani náš server dedokáže prečítať, čo ste vytvorili.",
    "button_startSession": "Začať schôdzu",
    "button_stopSession": "Ukončiť schôdzu",
    "desc_inProgressIntro": "Práve prebieha živá schôdza.",
    "desc_shareLink": "Zdieľajte tento odkaz s osobou, s ktorou chcete spolupracovať:",
    "desc_exitSession": "Ukončenie schôdze vás odpojí z miestnosti, avšak naďalej budete môcť pokračovať v práci na scéne lokálne. Toto neovplyvní ostatných spolupracovníkov a stále budú môcť spolupracovať na ich verzii.",
    "shareTitle": "Pripojiť sa k živej schôdzi na Excalidraw"
  },
  "errorDialog": {
    "title": "Chyba"
  },
  "exportDialog": {
    "disk_title": "Uložiť na disk",
    "disk_details": "Exportovať údaje scény do súboru, z ktorého môžu byť neskôr importované.",
    "disk_button": "Uložiť do súboru",
    "link_title": "Odkaz na zdieľanie",
    "link_details": "Exportovať ako odkaz iba na čítanie.",
    "link_button": "Exportovať ako odkaz",
    "excalidrawplus_description": "Uložiť scénu do vášho Excalidraw+ pracovného priestoru.",
    "excalidrawplus_button": "Exportovať",
    "excalidrawplus_exportError": "Nepodarilo sa vykonať export do Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Prečítajte si náš blog",
    "click": "kliknutie",
    "deepSelect": "Výber v skupine",
    "deepBoxSelect": "Výber v skupine alebo zamedzenie poťiahnutia",
    "curvedArrow": "Zakrivená šípka",
    "curvedLine": "Zakrivená čiara",
    "documentation": "Dokumentácia",
    "doubleClick": "dvojklik",
    "drag": "potiahnutie",
    "editor": "Editovanie",
    "editLineArrowPoints": "Editácia bodov čiary/šípky",
    "editText": "Editácia textu / pridanie štítku",
    "github": "Objavili ste problém? Nahláste ho",
    "howto": "Postupujte podľa naších návodov",
    "or": "alebo",
    "preventBinding": "Zakázať pripájanie šípky",
    "tools": "Nástroje",
    "shortcuts": "Klávesové skratky",
    "textFinish": "Ukončenie editovania (text editor)",
    "textNewLine": "Vložiť nový riadok (text editor)",
    "title": "Pomocník",
    "view": "Zobrazenie",
    "zoomToFit": "Priblížiť aby boli zahrnuté všetky prvky",
    "zoomToSelection": "Priblížiť na výber",
    "toggleElementLock": "Zamknúť/odomknúť vybrané",
    "movePageUpDown": "Posunúť stranu hore/dole",
    "movePageLeftRight": "Posunúť stranu doľava/doprava"
  },
  "clearCanvasDialog": {
    "title": "Vyčistiť plátno"
  },
  "publishDialog": {
    "title": "Uverejniť knižnicu",
    "itemName": "Názov položky",
    "authorName": "Meno autora",
    "githubUsername": "Github užívateľské meno",
    "twitterUsername": "Twitter užívateľské meno",
    "libraryName": "Názov knižnice",
    "libraryDesc": "Popis knižnice",
    "website": "Webová stránka",
    "placeholder": {
      "authorName": "Vaše meno alebo užívateľské meno",
      "libraryName": "Názov vašej knižnice",
      "libraryDesc": "Popis vašej knižnice, ktorý ostatným pomôže porozumieť jej vhodnému použitiu",
      "githubHandle": "GitHub užívateľské meno (nepovinné), aby ste mohli robiť úpravy po tom, čo bude knižnica uverejnená na schválenie",
      "twitterHandle": "Twitter užívateľské meno (nepovinné), aby sme vedeli komu pripísať zásluhu pri propagovaní cez Twitter",
      "website": "Odkaz na vašu osobnú webovú stránku alebo niekam inam (nepovinné)"
    },
    "errors": {
      "required": "Povinné",
      "website": "Zadajte platnú adresu URL"
    },
    "noteDescription": "Uverejnite vašu knižnicu vo <link>verejnom zozname knižníc</link>aby ju aj ostatní mohli použiť v ich náčrtoch.",
    "noteGuidelines": "Knižnica musí byť najprv manuálne schválená. Prosím prečítajte si <link>pokyny</link> pred uverejnením. Budete potrebovať Github účet na komunikáciu a vykonanie zmien, ak budú potrebné, avšak nie je to úplne povinné.",
    "noteLicense": "Potvrdením súhlasíte, že knižnica bude zverejnená s <link>MIT licenciou, </link>čo v skratke znamená, že ju môže použiť hocikto bez obmedzení.",
    "noteItems": "Každá položka v knižnici musí mať svoje vlastné meno, aby sa dala vyhľadať. Súčasťou knižnice budú nasledujúce položky:",
    "atleastOneLibItem": "Začnite prosím zvolením aspoň jednej položky z knižnice",
    "republishWarning": "Poznámka: Niektoré z vybraných položiek sú už označené ako zverejnené. Ich znovu uverejnenie by ste mali vykovať iba vtedy ak aktualizujete už existujúcu knižnicu alebo požiadavku na uverejnenie."
  },
  "publishSuccessDialog": {
    "title": "Knižnica uverejnená",
    "content": "Ďakujeme vám {{authorName}}. Vaša knižnica bola uverejnená na posúdenie. Stav môžete skontrolovať<link>tu</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Obnoviť knižnicu",
    "removeItemsFromLib": "Odstrániť zvolené položky z knižnice"
  },
  "imageExportDialog": {
    "header": "Exportovať obrázok",
    "label": {
      "withBackground": "Pozadie",
      "onlySelected": "Iba vybrané",
      "darkMode": "Tmavý režim",
      "embedScene": "Zahrnúť scénu",
      "scale": "Mierka",
      "padding": "Odsadenie"
    },
    "tooltip": {
      "embedScene": "Údaje scény budú uložené do exportovaného PNG/SVG súboru, takže scéna z neho môže byť opäť obnovená.\nBude to mať za následok zvýšenie veľkosti súboru."
    },
    "title": {
      "exportToPng": "Exportovať do PNG",
      "exportToSvg": "Exportovať do SVG",
      "copyPngToClipboard": "Kopírovať PNG do schránky"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopírovať do schránky"
    }
  },
  "encrypted": {
    "tooltip": "Vaše kresby používajú end-to-end šifrovanie, takže ich Excalidraw server nedokáže prečítať.",
    "link": "Blog o end-to-end šifrovaní v Excalidraw"
  },
  "stats": {
    "angle": "Uhol",
    "element": "Prvok",
    "elements": "Prvky",
    "height": "Výška",
    "scene": "Scéna",
    "selected": "Vybrané",
    "storage": "Úložisko",
    "title": "Štatistiky",
    "total": "Celkom",
    "version": "Verzia",
    "versionCopy": "Kliknutím skopírujete",
    "versionNotAvailable": "Verzia nie je k dispozícii",
    "width": "Šírka"
  },
  "toast": {
    "addedToLibrary": "Pridané do knižnice",
    "copyStyles": "Štýly skopírované.",
    "copyToClipboard": "Skopírované do schránky.",
    "copyToClipboardAsPng": "Kopírovanie {{exportSelection}} do schránky ako PNG prebehlo úspešne\n({{exportColorScheme}})",
    "fileSaved": "Súbor uložený.",
    "fileSavedToFilename": "Uložený ako {filename}",
    "canvas": "plátna",
    "selection": "výberu",
    "pasteAsSingleElement": "Použitím {{shortcut}} vložte ako samostatný prvok alebo vložte do existujúceho editovaného textu",
    "unableToEmbed": "Zapustenie tejto URL nie je povolené. Vytvorte issue na GitHub-e a požiadajte povolenie tejto URL",
    "unrecognizedLinkFormat": "Odkaz, ktorý sa snažíte zapustiť nie je v očakávanom formáte. Prosím skúste vložiť 'odkaz na zdieľanie' poskytnutý zdrojovou webovou stránkou"
  },
  "colors": {
    "transparent": "Priehľadná",
    "black": "Čierna",
    "white": "Biela",
    "red": "Červená",
    "pink": "Ružová",
    "grape": "Hroznová fialová",
    "violet": "Fialová",
    "gray": "Sivá",
    "blue": "Modrá",
    "cyan": "Azúrová",
    "teal": "Modrozelená",
    "green": "Zelená",
    "yellow": "Žltá",
    "orange": "Oranžová",
    "bronze": "Bronzová"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Všetky vaše dáta sú uložené lokálne vo vašom prehliadači.",
      "center_heading_plus": "Chceli ste namiesto toho prejsť do Excalidraw+?",
      "menuHint": "Exportovanie, nastavenia, jazyky, ..."
    },
    "defaults": {
      "menuHint": "Exportovanie, nastavenia a ďalšie...",
      "center_heading": "Diagramy. Jednoducho.",
      "toolbarHint": "Zvoľte nástroj a začnite kresliť!",
      "helpHint": "Klávesové skratky a pomocník"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Najpoužívanejšie vlastné farby",
    "colors": "Farby",
    "shades": "Odtiene",
    "hexCode": "Hex kód",
    "noShades": "Pre túto farbu nie sú dostupné žiadne odtiene"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportovať ako obrázok",
        "button": "Exportovať ako obrázok",
        "description": "Exportovať údaje scény ako obrázok, z ktorého môžu byť neskôr importované."
      },
      "saveToDisk": {
        "title": "Uložiť na disk",
        "button": "Uložiť na disk",
        "description": "Exportovať údaje scény do súboru, z ktorého môžu byť neskôr importované."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportovať ako Excalidraw+",
        "description": "Uložiť scénu do vášho Excalidraw+ pracovného priestoru."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Načítať zo súboru",
        "button": "Načítať zo súboru",
        "description": "Načítanie zo súboru <bold>nahradí váš existujúci obsah</bold>.<br></br>Vašu kresbu môžete zálohovať jednou z nižšie uvedených možností."
      },
      "shareableLink": {
        "title": "Načítať z odkazu",
        "button": "Nahradiť môj obsah",
        "description": "Načítanie externej kresby <bold>nahradí váš existujúci obsah</bold>.<br></br>Vašu kresbu môžete zálohovať jednou z nižšie uvedených možností."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid do Excalidraw",
    "button": "Vložiť",
    "description": "Aktuálne sú podporované iba <flowchartLink>vývojové diagramy</flowchartLink>, <sequenceLink>sekvenčné diagramy</sequenceLink> a <classLink>diagramy tried</classLink>. Ostatné typy budú v Excalidraw vykreslené ako obrázky.",
    "syntax": "Mermaid syntax",
    "preview": "Ukážka"
  }
}
